<script>
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';
import { Xhr } from 'tortilla';

export default {
    props: {
        defaultTab: {type: String, required: true}
    },
    data: () => ({
        activeTab: undefined,
        previousTab: undefined,
        filter: '-1',
        isLoading: true,
        config: {
            'our-home-designs': {
                API: '/api/media-gallery/residences',
                GALLERY: []
            },
            'tour-our-communities': {
                API: '/api/media-gallery/tours', // change this
                GALLERY: []
            }
        }
    }),
    computed: {
        gallery() {
            return this.config[this.activeTab].GALLERY;
        },
        isGalleryEmpty() {
            return this.filter !== '-1' && !this.gallery.some((val) => val.community_id == this.filter);
        }
    },
    watch: {
        activeTab(val) {
            if (this.config[val].GALLERY.length === 0) {
                this.isLoading = true;
                this.getGallery();
            } else {
                this.isLoading = false;
            }
        }
    },
    created() {
        this.readHash();
        this.getGallery();
    },
    mounted() {
        window.addEventListener('hashchange', this.readHash, false);
    },
    beforeDestroy() {
        window.removeEventListener('hashchange', this.readHash);
    },
    methods: {
        ...mapActions({
            put: 'slick/put',
            videoPut: 'modal/put'
        }),
        updateHash() {
            const newUrl = document.location.pathname;
            const hash = this.activeTab ? `#${this.defaultTab}` : `#${this.activeTab}`;
            history.replaceState({newUrl}, '', newUrl + hash);
        },
        readHash() {
            const hash = window.location.hash;
            this.activeTab = hash.slice(1) || this.defaultTab;
        },
        getGallery() {
            return Xhr.get(this.config[this.activeTab].API).then((response) => {
                this.config[this.activeTab].GALLERY = response.data;
                this.isLoading = false;
            }).catch((err) => {
                this.config[this.activeTab].GALLERY = [];
                this.isLoading = false;
                console.error(err);
            });
        },
        getVideoImage(gallery) {
            return gallery.images.alternative_cover_image.exists ?      gallery.image.alternative_cover_image.medium : gallery.images.youtube.medium;
        },
        handleError(e) {
            console.log('error');
            console.log(e);
            console.log('--------------------');
        }
    }
};
</script>
